<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <h1 class="sci-page-title-only">Retroatividade</h1>
        <p class="text-sm text-slate-500">Ajuste retroativo de quilometragem e consumo</p>
      </div>

      <!-- CONFIGURAÇÕES DE RETROATIVIDADE -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-custom">
          <div class="px-6 py-4" style="background-color: #333333;">
              <h2 class="text-white font-bold flex items-center gap-2 uppercase tracking-widest text-[11px]">
                  <v-icon color="orange" small class="mr-2">mdi-history</v-icon>
                  PARÂMETROS DE AJUSTE
              </h2>
          </div>
          <div class="px-6 pt-6 pb-10">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="retroactValues.average_min"
                    label="Média Mínima"
                    outlined
                    dense
                    type="number"
                    min="0"  step="0.1"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="retroactValues.average_max"
                    label="Média Máxima"
                    outlined
                    dense
                    type="number"
                    min="0"  step="0.1"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <Date
                    @dateValue="[(retroactValues.startDate = $event)]"
                    label="Data Inicial"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <Date
                    @dateValue="[(retroactValues.endDate = $event)]"
                    label="Data Final"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    v-model="retroactValues.prefecture_id"
                    label="Prefeitura"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    outlined
                    dense
                    @change="getVehicles(retroactValues.prefecture_id)"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-autocomplete
                    label="Veículo"
                    :rules="fieldRules"
                    :items="vehicles"
                    item-value="vehicle_id"
                    item-text="vehicle_board"
                    v-model="retroactValues.vehicle_id"
                    outlined
                    dense
                  >
                    <template slot="selection" slot-scope="{ item }"
                      >{{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_board }}</template
                    >
                    <template slot="item" slot-scope="{ item }"
                      >{{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_board }}</template
                    >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="retroactValues.last_km"
                    label="Retroagir de (KM Final)"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="retroactValues.first_km"
                    label="Não ultrapassar (KM Inicial)"
                    outlined
                    dense
                  />
                </v-col>
              </v-row>

              <div class="flex justify-end mt-8">
                  <button 
                    @click="retroact" 
                    :disabled="!(retroactValues.startDate && retroactValues.endDate && retroactValues.prefecture_id && retroactValues.vehicle_id && retroactValues.last_km)"
                    class="bg-orange-500 hover:bg-orange-600 text-white rounded-lg shadow-md shadow-orange-500/20 flex items-center justify-center gap-2 w-fit whitespace-nowrap px-8 h-10 transition-all transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed text-[11px] font-bold uppercase tracking-widest"
                  >
                      <v-icon color="white" small class="mr-1">mdi-play-outline</v-icon>
                      EXECUTAR AJUSTE
                  </button>
              </div>
          </div>
      </section>

      <v-snackbar
        multi-line
        :color="snack.color"
        v-model="snack.show"
        transition="fade-transition"
        top
        right
      >
        {{ snack.message }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="snack.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    prefectures: [],
    vehicles: [],
    retroactValues: {
      average_min: 0,
      average_max: 0,
      first_km: 0,
      last_km: 0,
      prefecture_id: null,
      vehicle_id: null,
      startDate: null,
      endDate: null,
    },
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    loader: false,
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    getVehicles(prefecture_id) {
      this.$http.get(`/vehicles/prefectures/${prefecture_id}`).then((r) => {
        this.vehicles = r.data;
      });
    },

    emptyValues() {
      this.retroactValues.prefecture_id = null;
      this.retroactValues.vehicle_id = null;
      this.retroactValues.startDate = null;
      this.retroactValues.endDate = null;
      this.retroactValues.last_km = 0;
    },
    retroact() {
      let c = confirm("Essa operação não poderá ?");
      if (c) {
        this.$http
          .post("/supplies/repairkms", this.retroactValues)
          .then((r) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = r.data.result;
            // this.emptyValues();
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
  },
};
</script>

<style>
</style>